module.exports = __webpack_public_path__ + "img/floorSix.ebc0fabb.png";